import * as React from 'react';
// @ts-expect-error
import {components} from 'react-select';
// @ts-expect-error
import type {OptionProps} from 'react-select';

import classnames from 'classnames';

import {getSingularEntityType} from 'nutshell-core/utils';

import {Avatar} from 'shells/avatar/avatar';

import {GraphQLSelectInline} from './graphql-select-inline';
import type {Option} from './graphql-select-inline';
import {useGetLeads} from './hooks/use-get-leads';

import styles from './graphql-select-options.module.css';

type Props = {
    placeholder?: string;
    selectedValues: Option[];
    onChange: (values: Option[]) => any;
    onBlur?: () => void;
    onClearValue?: () => void;
    isMulti: boolean;
    clearable?: boolean;
    disabled?: boolean;
    hasDropdownIndicator?: boolean;
    searchable?: boolean;
    openMenuOnClick?: boolean;
    defaultOptions?: true | any[];
    controlShouldRenderValue?: boolean;
    autoFocus?: boolean;
};

export function GraphQLSelectLeads(props: Props) {
    const {fetchMore, isLoading} = useGetLeads();

    // @ts-expect-error
    const handleLoadOptions = (search) => {
        return fetchMore(search).then(({data}) => {
            const quickResults = data.search ? data.search.quickResults : null;
            const leadResults = quickResults ? quickResults.leadResults : [];

            // @ts-expect-error
            const mappedLeadResults = leadResults.map((lead) => ({
                ...lead,
                metaData: {
                    href: lead.htmlUrl,
                },
            }));

            return Promise.resolve(mappedLeadResults);
        });
    };

    return (
        <div>
            <GraphQLSelectInline
                placeholder={props.placeholder || 'Type to search for leads…'}
                value={props.selectedValues}
                multi={props.isMulti}
                defaultOptions={props.defaultOptions}
                onClearValue={props.onClearValue}
                loadOptions={handleLoadOptions}
                onChange={props.onChange}
                onBlur={() => {
                    props.onChange(props.selectedValues);
                    if (props.onBlur) {
                        props.onBlur();
                    }
                }}
                noOptionsMessage={({inputValue}) => {
                    if (isLoading) {
                        return 'Getting recommended results…';
                    }
                    if (inputValue.length) {
                        return `No leads found matching '${inputValue}'`;
                    }
                    if (inputValue.length === 0) {
                        return 'No leads found';
                    }

                    return null;
                }}
                components={{Option: OptionComponent}}
                labelKey='name'
                valueKey='id'
                clearable={props.clearable}
                shouldStyleValueByType={true}
                disabled={props.disabled}
                hasDropdownIndicator={props.hasDropdownIndicator}
                searchable={props.searchable}
                openMenuOnClick={props.openMenuOnClick}
                controlShouldRenderValue={props.controlShouldRenderValue}
                autoFocus={props.autoFocus}
            />
        </div>
    );
}

const OptionComponent = (props: OptionProps) => {
    const spreadableProps = props;

    const name = props.data.name ? (
        <div className={styles['option-label-with-wrap']}>{props.data.name}</div>
    ) : (
        <div className={classnames('italic', styles['option-label-with-wrap'])}>
            Unnamed {getSingularEntityType('leads')}
        </div>
    );

    return (
        <components.Option {...spreadableProps}>
            <div className={styles['option-wrapper']}>
                <Avatar
                    avatarUrl={props.data.avatarUrl}
                    initials={props.data.initials}
                    type='leads'
                />
                {name}
            </div>
        </components.Option>
    );
};
